import React, { useState, useEffect } from "react";
import { ListItem, ListItemText, useTheme } from "@mui/material";
import { SidebarItemProps } from "../../types/interface";
import { useNavigate, useLocation } from "react-router-dom";
import VisionStudioSvg from "../VisionStudioSvg";

/**
 * Reusable component to generate SideBar Items
 * @param {object} SidebarItemProps
 * @property {string} title
 * @property {string} icon
 * @property {string} link
 */
export const VisionStudioSidebarItem: React.FC<SidebarItemProps> = ({
  title,
  icon,
  link,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const location = useLocation();

  const [activeItem, setActiveItem] = useState<string>("");

  // Handle click on sidebar item
  const handleClick = (link: string) => {
    navigate(`/${link}`);
    setActiveItem(link);
    localStorage.setItem("activeTab", "0");
  };

  const isActive =
    location.pathname === `/${link}` ||
    activeItem === link ||
    (link === "projects" && location.pathname.includes("project"));

  useEffect(() => {
    // Sync active item with the current path
    setActiveItem(location.pathname.slice(1)); // Remove leading "/" from pathname
  }, [location.pathname]);

  return (
    <ListItem
      onClick={() => handleClick(link)}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        cursor: "pointer",
        fontSize: "100",
        backgroundColor: isActive ? " #E1EDFB" : "transparent",
        borderLeft: isActive ? "5px solid #1D97F3" : "5px solid transparent",
        padding: "10px 0",
      }}
      sx={{
        "&:hover": {
          transform: "scale(1.09)", // Scale on hover
          transition: "transform 0.1s cubic-bezier(1, 1, 1, 1)", // Smooth, custom easing
        },
      }}
    >
      <VisionStudioSvg
        icon={icon}
        style={{
          minWidth: "auto",
          height: "20px",
          width: "20px",
          color: isActive
            ? theme.palette.primary.main
            : theme.palette.text.primary,
        }}
      />

      <ListItemText
        primary={title}
        sx={{
          fontSize: theme.typography.subtitle2.fontWeight,
          "&.MuiListItemText-root span": {
            fontSize: theme.typography.caption.fontSize,
            fontWeight: theme.typography.fontWeightRegular,
            lineHeight: "18px",
          },
        }}
        style={{
          textAlign: "center",
          color: isActive ? "black" : "", // Text color changes based on active state
        }}
      />
    </ListItem>
  );
};
